import React from "react";
import { renderToString } from "react-dom/server";


export interface IoadDatatoTable {
  filter: string[];
  header: string[];
  body:
  | Array<{ [key: string]: string | number | boolean }>
  | Array<(string | number | boolean)[]>;
}

export default function createTable({ filter, header, body }: IoadDatatoTable) {

  const filterCell = (
    <tr>
      {filter.map((filter, i) => (
        <th key={i}>{filter}</th>
      ))}
    </tr>
  );

  const headCell = (
    <tr>
      {header.map((head, i) => (
        <th key={i}>{head}</th>
      ))}
    </tr>
  );

  const dataCEll = body.map((val, i) => {
    if (Array.isArray(val)) {
      return (
        <tr key={i}>
          {val.map((value, i) => (
            <th key={i}> {value} </th>
          ))}
        </tr>
      );
    }

    if (val !== null && typeof val === "object") {
      return (
        <tr key={i}>
          {Object.entries(val).map(([key, value], i) => {
            if (typeof value === "object") {
              return <th key={i}></th>;
            }

            return (
              <th key={i}>
                <>{value}</>
              </th>
            );
          })}
        </tr>
      );
    }

    return null;
  });

  return renderToString(
    <table>
      <tbody>
        {filterCell}
        {headCell}
        {dataCEll}
      </tbody>
    </table>
  );
}
